import { memo, ReactNode, Ref } from 'react'
import cn from 'classnames'
import { Text } from 'src/components/extend/Text'
import { Title } from 'src/components/extend/Title'

interface IProps {
  children: ReactNode
  action?: ReactNode
  className?: string
  description?: string
  innerRef?: Ref<HTMLDivElement>
  title?: string
}

const Widget = memo(function Widget({ className, title, action, description, children, innerRef }: IProps) {
  const hasHeader = Boolean(title || description || action)

  return (
    <div
      ref={innerRef}
      className={cn(
        'w-full shadow-[0_1px_3px_rgba(26,28,30,0.2)]',
        'md:rounded-[3px]',
        'max-3md:shadow-[none]',
        'bg-on-primary',
        className
      )}
    >
      {hasHeader && (
        <div className="flex flex-wrap justify-between px-0 py-2">
          <div className="px-6 pb-2 pt-4">
            <Title size="h2">{title}</Title>
            {description && (
              <Text block color="secondary">
                {description}
              </Text>
            )}
          </div>

          {action && <div className="px-6 pb-2 pt-4">{action}</div>}
        </div>
      )}
      {children}
    </div>
  )
})

export default Widget
